import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {FaEdit } from 'react-icons/fa';
import couterpart from 'counterpart';
import Dialog from 'react-bootstrap-dialog';

import AuthenticationService from '../services/AuthenticationService';
import WorkOrderDataService from '../services/WorkOrderDataService';
import MasterDataService from '../services/MasterDataService';

import "../css/style.css";
import {ICON_COLOR} from '../icon';
import { EVENT_NAME_CHANGE_WO_STATUS, EVENT_NAME_UPDATE_WO_DETAILS } from '../constants';

class WorkOrderButtons extends Component {
    state = {
        workOrder: {},
        allStatus: []
    }

    componentDidMount () {
        MasterDataService.retrieveAllStatus().then(data => {
            this.setState({ allStatus:  data}) 
        }); 
    }   

    handleChangeNote(e){
        var snotesFromAdmin = "";
        var snotesFromDesigner = "";
        var snotesFromWorker = "";
        var snotesFromService = "";
        var newValue = e.target.value;
        if (AuthenticationService.isAdmin()){
            snotesFromAdmin = newValue;
        }else if (AuthenticationService.isWorker()){
            snotesFromWorker = newValue;
        }else if (AuthenticationService.isService()){
            snotesFromService = newValue;
        }else if (AuthenticationService.isDesigner()){
            snotesFromDesigner = newValue;
        }else if (AuthenticationService.isUser()){
            snotesFromWorker = newValue;
        }
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              notesFromService: snotesFromService,
              notesFromDesigner: snotesFromDesigner,
              notesFromWorker: snotesFromWorker,
              notesFromAdmin: snotesFromAdmin
            }
        }));
    }

    handleSelectStatusChange(e){
        const status = parseInt(e.target.value);
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,
              status: status,          
            },
            clicked: false
        }));
    }

    handleChangeStatus(e){
        this.dialog.show({
            title: couterpart.translate("msg_title_confirm"),
            body: couterpart.translate("msg_change_confirm"),
            actions: [
                Dialog.CancelAction(),
                Dialog.OKAction(() =>{
                    let sUpdater = "";
                        if (AuthenticationService.isAdmin()){
                            sUpdater = "ADMIN";
                        }else if (AuthenticationService.isWorker()){
                            sUpdater = "WORKER";
                        }else if (AuthenticationService.isService()){
                            sUpdater = "SERVICE";
                        }else if (AuthenticationService.isDesigner()){
                            sUpdater = "DESIGNER";
                        }else if (AuthenticationService.isUser()){
                            sUpdater = "WORKER";
                        }

                        this.setState(prevState => ({
                            workOrder: {
                            ...prevState.workOrder,
                            updater: sUpdater,
                            id: this.props.workOrderId,
                            orderInfoId: this.props.orderId,
                            workCardId: this.props.workCardId,
                            eventName: AuthenticationService.getRole() + "_" + EVENT_NAME_CHANGE_WO_STATUS,     
                            },
                            clicked: true
                        }));
                })
            ],
            bsSize: 'small',
            onHide: (dialog) => {
                dialog.hide()
                console.log('closed by clicking background.')
            }
        });        
    }

    componentDidUpdate(prevProps, prevState) {
        let noteOnly = false;
        if((this.state.workOrder.status === null) || 
            (this.state.workOrder.status === undefined) || 
            (this.state.workOrder.status === -1)){
                noteOnly = true;
        }
        if (this.state.clicked === true){
            if (noteOnly){
                WorkOrderDataService.updateNoteOfWorkOrder(this.state.workOrder).then(data => {
                    if (AuthenticationService.isAdmin() || AuthenticationService.isService()){
                        this.props.history.push("/orders");
                    }else{
                        this.props.history.push("/workOrders");
                    }
                });
            } else {
                WorkOrderDataService.updateStatusOfWorkOrder(this.state.workOrder).then(data => {
                    if (AuthenticationService.isAdmin() || AuthenticationService.isService()){
                        this.props.history.push("/orders");
                    }else{
                        this.props.history.push("/workOrders");
                    }
                });
            }
        }
    }

    renderNoteSelectForWorker(){
        return(          
            <div>
                { this.renderNoteLabel() }
                <input type="text" name="notesFromWorker" size="5" className="inputBox"
                    onChange={this.handleChangeNote.bind(this)}/>
            </div> 
        );
    }

    renderNoteSelectForDesigner(){
        return(
            <div>
                { this.renderNoteLabel() }
                <input type="text" name="notesFromService" size="5" className="inputBox"
                    onChange={this.handleChangeNote.bind(this)}/>
            </div>            
        );
    }

    renderStatusListForWorker(){
        return (
            <select defaultValue="-1" onChange={this.handleSelectStatusChange.bind(this)}>
                <option key="-1" value="-1"></option>
                {   this.state.allStatus.filter(y =>{
                        return (y.type === 2) && 
                            (y.usedBy.indexOf("WORKER") >= 0) && 
                            (this.props.currentStatus !== y.status);
                    }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)
                }
            </select>             
        );
    }

    getCurrentStatus(status){
        if (this.state.allStatus === undefined || this.state.allStatus.length < 1){
            return status;
        }

        let currentStatus = this.state.allStatus.find(x => {
            return x.status === status;
        });
        return currentStatus.statusDescVn;
    }

    renderStatusListFor(role){
        console.log('role', role);
        if (this.state.allStatus === undefined || this.state.allStatus === null){ //35: Xong thiet ke
            return (<></>);
        }

        if (role === 'DESIGNER'){
            return (
                <select defaultValue="-1" onChange={this.handleSelectStatusChange.bind(this)}>
                    <option key="-1" value="-1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</option>
                    {   this.state.allStatus.filter(y =>{
                            //let x = (y.type === 2) && (y.usedBy.indexOf(role) >= 0) && (this.props.currentStatus < y.status);
                            let x = ((y.type === 2) && (y.usedBy.indexOf(role) >= 0) && (this.props.currentStatus < y.status)) || y.status === 1;
                            return x;
                        }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)
                    }
                </select> 
            );
        }        
        return (
            <select defaultValue="-1" onChange={this.handleSelectStatusChange.bind(this)}>
                <option key="-1" value="-1"></option>
                {   this.state.allStatus.filter(y =>{
                        let x = (y.type === 2) && (y.usedBy.indexOf(role) >= 0) && (this.props.currentStatus !== y.status);
                        return x;
                    }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)
                }
            </select> 
        );
    }

    renderSubmitButton(){
        return(
            <button name="btnChangeStatus" className="myButton" 
                onClick={this.handleChangeStatus.bind(this)}>
                <FaEdit color={ICON_COLOR}/>&nbsp;
                {couterpart.translate('button_change')}
            </button>
        );
    }

    renderChangeStatusLabel(){
        const label_status = couterpart.translate('label_status');
        return(
        <label><b>{label_status}</b></label>); 
    }

    renderNoteLabel(){
        const label_note = couterpart.translate('label_note');
        return(
        <label><b>{label_note}</b></label>); 
    }

    renderCurrentStatus(){
        return(
            <div>
                <label><b>{ couterpart.translate('label_current_status') }</b>: &nbsp; 
                { this.getCurrentStatus(this.props.currentStatus) }</label> 
            </div>
        );
    }

    render() {
        if (AuthenticationService.isWorker()){
                return(
                <div>
                    { this.renderCurrentStatus() }
                    {this.renderChangeStatusLabel()}&nbsp;
                    {this.renderStatusListForWorker()}&nbsp;
                    {this.renderNoteSelectForWorker()}&nbsp;
                    {this.renderSubmitButton()}
                    <Dialog ref={(component) => { this.dialog = component }} />
                </div>
                );
        }

        if (AuthenticationService.isDesigner()){
            return (
                <div>
                    { this.renderCurrentStatus() }
                    {this.renderChangeStatusLabel()}&nbsp;
                    {this.renderStatusListFor("DESIGNER")}&nbsp;
                    {this.renderNoteSelectForDesigner()}&nbsp;
                    {this.renderSubmitButton()}
                    <Dialog ref={(component) => { this.dialog = component }} />
                </div>
            )
        }

        if (AuthenticationService.isKhac()){
            return (
                <div>
                    { this.renderCurrentStatus() }
                    {this.renderChangeStatusLabel()}&nbsp;
                    {this.renderStatusListFor("KHAC")}&nbsp;
                    {this.renderSubmitButton()}
                    <Dialog ref={(component) => { this.dialog = component }} />
                </div>
            )
        }

        if (AuthenticationService.isShipping()){
            return (
                <div>
                    { this.renderCurrentStatus() }
                    {this.renderChangeStatusLabel()}&nbsp;
                    {this.renderStatusListFor("SHIPPING")}&nbsp;
                    {this.renderSubmitButton()}
                    <Dialog ref={(component) => { this.dialog = component }} />
                </div>
            )
        }

        return (<></>);
    }
}

export default withRouter(WorkOrderButtons)
